import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import UserList from "../../pages/User/UserList";
import CreateUser from "../../pages/User/CreateUser";
import EditUser from "../../pages/User/EditUser";
import UserProfile from "../../pages/User/UserProfile";
//@ts-ignore
import { PermissionRequired, AccessControl} from "@careinfo/permission-required";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<UserList />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/create" element={
            <AccessControl
            children={
            <CreateUser />
            }
            allowedPermissions={["can_create_user"]}
            renderNoAccess={<PermissionRequired/>}
            />
          } />
          <Route path="/edit/:id" element={
              <AccessControl
              children={
                <EditUser />
              }
              allowedPermissions={["can_update_user"]}
              renderNoAccess={<PermissionRequired/>}
              />
            } />
          <Route path="/profile" element={<UserProfile />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;